<template>
  <div
    class="pic-resources-wrap" v-if="picResources.length ">
    <div class="pic-title">
      <div class="pic-resources">
        <i class="icon_resources" />
        更多系列图片
      </div>
      <div
        class="buy-pic-package buy-btn"
        v-if=" detail.package === 1 && !detail.is_buy"
        @click="buyLeaflet"
      >
        <span class="name">购买此包</span>
<!--        <i class="icon_dollar">￥</i>-->
<!--        <span class="price">{{ detail.package_price }} </span>-->
        <span class="text"> / {{ detail.pic_num - 1 }}张</span>
      </div>

      <div
        v-if=" detail.package === 1 && detail.is_buy"
        class="buy-pic-package buy-btn buy-btn-download"
        @click="download(2,detail.uniq_id)"
      >
        <i class="iconfont icon-pack"/>
        源文件打包下载
      </div>


    </div>

    <PicList
      :isShowPicTitle="true"
      class="PicList2"
      :class="[ picResources[0].show_square == 1 ? 'PicListSquare': 'PicListLong']"
      :pic-list="picResources"
    >
      <div
        slot="morePicItem"
        v-if="!!detail.master_id && trendPicsCover != null"
        :class="[ picResources[0].show_square == 1 ? 'pic-item-1': 'pic-item-2']"
        class="PicItem pic-item pic-item-mask"
        @click="navigateTo(detail.master_id)"

      >

        <div class="pic-hover-title overflow-one" >
          {{ trendPicsCover.title }}
        </div>

        <div class="bg"
             v-if="picResources[0].show_square == 1"
             :style="boxWrapStyle"></div>
<!--        <div
        >
          <i class="icon_more-pic"/>
          <div>购买完整图片包</div>
        </div>-->
        <img
          v-lazy=" IMG_BASE_URL + trendPicsCover.proto_pic + '!/fw/279/quality/90/unsharp/true/compress/true'"
          v-if="picResources[0].show_square == 1"
          class="pic-img pic-img-1 pic-img-square">
        <img
          v-lazy=" IMG_BASE_URL + trendPicsCover.proto_pic + '!/fw/279/quality/90/unsharp/true/compress/true' "
          v-else
          class="pic-img pic-img-2">

        <!-- 标签 -->
        <PicTagLegalCopy :pic-item-info="trendPicsCover"/>




      </div>
    </PicList>

    <!-- 下载限制弹框 -->
    <DownloadInterceptDialog
      :time="clippingTime"
      ref="DownloadInterceptDialog"
    />
  </div>
</template>

<script>
import {IMG_BASE_URL, MATERIAL_DETAIL, MEMBER_LICENSE_VIP} from "@/constant/PATH";
import {DownloadInterceptDialog} from "@/components/material";
import {downStat, toggleMaterialCollect} from "~/api/material";
import {fnLogin, fnRouter} from "~/fn";
import _ from 'lodash';
import PicList from '@/components/pic/pic-list/pic-list';
import {toolDevice} from "@/tools";
import {BROWSERS} from "@/constant/SYSTEM";
import {packageStat} from "@/api/stat";
import axios from "axios";
import PicTagLegalCopy from '@/components/pic/pic-tag/pic-tag-legal-copy';
import * as CON_COMMON from "@/constant/_constant";
import * as fnCommon from "@/fn/_fn";
import FnUser from "@/fn/_fn/FnUser";



export default {
  name: "TuPianDetailsPicResources",
  props: {
    picResources: {
      type: Array | Object,
      default: () => {
      }
    },
    detail: {
      type: Object,
      default: () => {
      }
    },
    trendPicsCover: {
      type:  Object,
      default: () => {
      }
    },


  },
  computed:{
    boxWrapStyle() {
      return `
      background-image: url(https://pic.chaopx.com${this.trendPicsCover.preview_water_pic});
      background-size: cover;


      `
    },
  },
  components: {
    DownloadInterceptDialog,
    PicList,
    PicTagLegalCopy
  },
  data() {
    return {
      IMG_BASE_URL,
      MATERIAL_DETAIL,
      clippingTime: 0, // 下载限制时间
      MEMBER_LICENSE_VIP
    }
  },
  methods: {
    showPayDialog() {
      this.$emit('showPayDialog')
    },
    download(channel, uniq_id) {
      let tempStr = `https://dl.chaopx.com/down/download?channel=${channel}&uniq_id=${uniq_id}&module=2`
      axios.get(tempStr).then(res => {
        let {status, time, url, msg} = res.data.data;

        if (FnUser.checkCompanyVipExpiredModal()) {
          if (status == 0 || status == 2) {
            this.$store.commit('Modal/SET_COMPANY_VIP_EXPIRED_MODAL', true)
            return false;
          }
        }

        if (status === 1) {
          packageStat({event: 'down', channel: channel})
          downStat({uniq_id: uniq_id, module: 2})
          // window.location.href = url;
          // downStat({uniq_id})
          if (toolDevice.getCurrentBrowser() === BROWSERS.Safari) {
            setTimeout(() => {
              window.location.href = url;
            }, 200)
          } else {
            window.location.href = url;
          }

        } else if (status === -200) {
          this.clippingTime = time;
          this.$refs.DownloadInterceptDialog.isShow = true;
        } else {
          this.$myNotify.show(msg)
        }
      });
    },

    toggleCollect: _.throttle(function (vo, idx) {

      if (fnLogin.checkLogin()) {
        let isCollect = vo.isCollect || false
        const {uniq_id} = vo;
        let act = isCollect === false ? 'collect' : 'remove';
        toggleMaterialCollect({
          uniq_id,
          act
        }).then(res => {
          let msg = isCollect === false ? '收藏成功' : '已取消收藏';
          vo.isCollect = isCollect === false ? true : false;
          this.$set(this.picResources, idx, vo)
          this.$myNotify.success(msg);
        })
      } else {
        fnLogin.loginIntercept(false)
      }
    }, 2000),

    checkPicResourcesType(vo, key, idx) {
      console.log({
        vo, key, idx
      })
      let val = this.picResources;
      if (Object.prototype.toString.call(val) === '[object Array]') {
        console.log('-------Array')
        this.$set(val, key, vo)
      } else if (Object.prototype.toString.call(val) === '[object Object]') {
        /*console.log('-------Object')
        console.log('key' + key)
        this.$set(this.picResources, key, {name:111})
        console.log(this.picResources[key])*/

        this.picResources[key] = {name: 111}
        console.log(this.picResources)
        /*console.log(this.picResources)
        this.$emit('updatePicResources',this.picResources)*/

      }
    },

    navigateTo(id) {
      let path = MATERIAL_DETAIL + '/' + id + '.html'
      fnRouter.navigationTo(path)
    },

    buyLeaflet(){
      let path = CON_COMMON.CON_BASIC.PAY_LEAFLET + `/${this.detail.uniq_id}.html`;
      fnCommon.fnPay.dataTrackByClickLeaflet()
      fnCommon.fnBasic.navigationTo(path)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common/pic-list";

.pic-resources-wrap {
  //margin-top: 40px;
  //margin-bottom: 0 !important;

  .pic-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .pic-resources{
      display: flex;
      align-items: center;
      font-size: 28px;
      font-weight: bold;
      color: #0A2540;
      line-height: 37px;
      letter-spacing: 1px;

      .icon_resources{
        @include BgImage(32px,32px,'/tupian/detail/img.svg');
        margin-right: 16px;
      }
    }



    .buy-btn {
      background: #F8CC44;
      font-size: 0;
      padding: 0 26px;
      box-sizing: border-box;
      height: 52px;
      border-radius: 14px;
      text-align: center;
      line-height: 52px;
      @include ElementHover('', #F8D568);

      .name {
        font-size: 18px;
        font-weight: bold;
        color: #2D2B33;
        //line-height: 52px;
      }

      .icon_dollar {
        font-size: 18px;
        font-weight: bold;
        color: #2D2B33;
        line-height: 24px;
        vertical-align: 1px;
      }

      .price {
        font-size: 26px;
        font-weight: bold;
        color: #2D2B33;
        line-height: 40px;
        margin: 0 2px 0 0px;
      }

      .text {
        font-size: 13px;
        color: #2D2B33;
        line-height: 18px;
        vertical-align: 1px;
      }
    }

    .buy-btn-download {
      display: flex;
      align-items: center;
      justify-content: center;

      .icon-pack {
        font-size: 22px;
        margin-right: 10px;
      }

      font-size: 18px;
      font-weight: bold;
      color: #2D2B33;
      line-height: 24px;
    }
  }
}


</style>
